(function () {
    document.addEventListener('DOMContentLoaded', function () {
        var posterPopup = document.getElementById('poster-popup');

        if (!posterPopup) {
            return;
        }

        var cookieHours = 24;
        var cookiePrefix = 'kayal_poster_seen_';
        var items = Array.prototype.slice.call(posterPopup.querySelectorAll('.poster-popup-item'));
        var visibleItems = [];
        var activeIndex = 0;
        var isClosing = false;

        function getCookie(name) {
            var cookieName = name + '=';
            var cookies = document.cookie.split(';');

            for (var i = 0; i < cookies.length; i++) {
                var cookie = cookies[i].trim();

                if (cookie.indexOf(cookieName) === 0) {
                    return cookie.substring(cookieName.length, cookie.length);
                }
            }

            return null;
        }

        function setPosterCookie(posterId) {
            var expiresAt = new Date();
            expiresAt.setTime(expiresAt.getTime() + (cookieHours * 60 * 60 * 1000));
            document.cookie = cookiePrefix + posterId + '=1; expires=' + expiresAt.toUTCString() + '; path=/; SameSite=Lax';
        }

        function showPoster(index) {
            items.forEach(function (item) {
                item.classList.remove('is-active', 'is-leaving');
            });

            isClosing = false;

            if (!visibleItems[index]) {
                posterPopup.remove();
                return;
            }

            visibleItems[index].classList.add('is-active');
            setPosterCookie(visibleItems[index].getAttribute('data-poster-id'));
            posterPopup.classList.add('is-visible');
        }

        function closeCurrentPoster() {
            var currentItem = visibleItems[activeIndex];

            if (!currentItem || isClosing) {
                return;
            }

            isClosing = true;
            currentItem.classList.add('is-leaving');

            window.setTimeout(function () {
                activeIndex++;
                showPoster(activeIndex);
            }, 220);
        }

        items.forEach(function (item) {
            var posterId = item.getAttribute('data-poster-id');

            if (posterId && !getCookie(cookiePrefix + posterId)) {
                visibleItems.push(item);
            }
        });

        if (!visibleItems.length) {
            posterPopup.remove();
            return;
        }

        showPoster(activeIndex);

        var closeButton = document.getElementById('poster-popup-close');
        var backdrop = posterPopup.querySelector('.poster-popup-backdrop');

        if (closeButton) {
            closeButton.addEventListener('click', function (event) {
                event.preventDefault();
                closeCurrentPoster();
            });
        }

        if (backdrop) {
            backdrop.addEventListener('click', function (event) {
                event.preventDefault();
                closeCurrentPoster();
            });
        }

        document.addEventListener('keyup', function (event) {
            if (event.key === 'Escape' && document.getElementById('poster-popup')) {
                closeCurrentPoster();
            }
        });
    });
})();
